import { createTag } from '@common/dynamic-loader';

const IDS_BY_APP = {
  aware: 'G-9D5ZMWNY34',
  onlineTesting: 'G-M91JZNWDE0',
  studentPortal: 'G-M91JZNWDE0',
  strive: 'G-DC8YGJX45M',
  crm: 'G-9R2PK3862M',
  management: 'G-E9DHB0TKX8'
};

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments); // eslint-disable-line
}
gtag('js', new Date());

export const init = (app, { organizationId, userId, username, organizationName }) => {
  const id = IDS_BY_APP[app] || IDS_BY_APP.aware;

  // dynamically load Google Analytics
  createTag('script', {
    async: true,
    src: `https://www.googletagmanager.com/gtag/js?id=${id}`
  });

  gtag('config', id, {
    user_properties: {
      // organizationId: "2d377901-6b88-4221-ae62-002e812cbd3e"
      organizationId,
      // userId: 359
      user_id: userId,
      userId,
      // username: "teacher@qademo.org"
      username,
      // organizationName: "Something ISD"
      organizationName: organizationName || ''
    }
  });
};

// Sample call:
//   track('category', 'action', 'label', value);
export const track = (...analyticsArgs) => {
  if (analyticsArgs.length >= 2) {
    const [category, action, label, value] = analyticsArgs;
    if (category !== 'online-testing') {
      // due to volume, do not send any online testing events
      gtag('event', action, {
        category,
        label,
        value
      });
    }
  } else {
    // eslint-disable-next-line
    console.error('>> Not enough parameters in google analytics event', analyticsArgs);
  }
};

// Use this convenience function to wrap an event handler with analytics
//
// Before:
//   <Button onClick={onAddNewPortfolio}>Label</Button>
//
// After:
//   <Button onClick={trackWrapper(onAddNewPortfolio, 'category', 'action')}>Label</Button>
//                    ^^^^^^^^^^^^^                 ^^^^^^^^^^^^^^^^^^^^^^^
export const trackWrapper = (functionToWrap, ...analyticsArgs) => {
  return (...fxnArgs) => {
    track(...analyticsArgs);
    return functionToWrap(...fxnArgs);
  };
};

export const getAnalyticsRoot = () =>
  (window?.location?.pathname?.match(/\/aware[v]?[2]?\/([a-z-0-9]+)[/]?/i) || [
    0,
    '(unknown)'
  ])[1];
